import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const count = ref(0)

function increment() {
  count.value++
}

// return the render function
const render = () => {
  return [
      h('div',
          {class: 'container-render-function'},
          [
    h(
        'h2',
        'Working with the render function'
    ),
    h(
        'div',
        {
          id: 'test-div',
          onClick: increment,
          innerHTML: 'Does this work? Click the button!'
        }
    ),
    h(
        'button',
        {
          style: {
            color: 'pink',
            backgroundColor: 'green',
            borderRadius: '5px',
          },
          onClick: increment
        },
        'Click me'
    ),
    h('p',
        ` ${count.value}`
    )]
      )
  ]
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(render))
}
}

})